import { ReactElement } from 'react'
import { FormControlLabel, Switch } from '@mui/material'

interface Props {
  checked: boolean
  label: string
  labelPlacement?: 'start' | 'end'
  onChange: (value: boolean) => void
}

const DevelopusRadio = (props: Props): ReactElement => {
  const labelPlacement = props.labelPlacement || 'start'

  const onChange = () => {
    props.onChange(!props.checked)
  }

  return (
    <div style={{ padding: '20px' }}>
      <FormControlLabel
        control={<Switch checked={props.checked} />}
        label={props.label}
        onChange={onChange}
        labelPlacement={labelPlacement}
      />
    </div>
  )
}

export default DevelopusRadio
